import { ClientException, ClientExceptionConstructor } from './client-exception';

export class NfcTagNotSupportedException extends ClientException implements ClientExceptionConstructor {
  constructor(message?: string, error?: Error) {
    super(message, error);
    this.name = 'NfcTagNotSupportedException';
  }

  static fromError(error: Error): NfcTagNotSupportedException {
    return new this(error.message, error);
  }
}
